import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgCross(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75886 6.34273C7.36834 5.9522 6.73518 5.9522 6.34465 6.34273C5.95413 6.73325 5.95413 7.36642 6.34465 7.75694L10.5869 11.9992L6.34359 16.2426C5.95307 16.6331 5.95307 17.2663 6.34359 17.6568C6.73412 18.0473 7.36728 18.0473 7.75781 17.6568L12.0012 13.4134L16.2441 17.6564C16.6347 18.047 17.2678 18.047 17.6584 17.6564C18.0489 17.2659 18.0489 16.6327 17.6584 16.2422L13.4154 11.9992L17.6573 7.75731C18.0478 7.36678 18.0478 6.73362 17.6573 6.34309C17.2668 5.95257 16.6336 5.95257 16.2431 6.34309L12.0012 10.585L7.75886 6.34273Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);

var CloseIconSVG = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { CloseIconSVG as C };
